if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();
        this._loaded = false;
      }

      connectedCallback() {
        if (this._loaded) return;

        const run = () => {
          if (this._loaded) return;
          this._loaded = true;
          this.init();
        };

        if (typeof FoxTheme !== 'undefined' && FoxTheme.Motion && FoxTheme.Motion.inView) {
          FoxTheme.Motion.inView(this, run, { margin: '0px 0px 200px 0px' });
        } else if ('requestIdleCallback' in window) {
          requestIdleCallback(run, { timeout: 2500 });
        } else {
          setTimeout(run, 500);
        }
      }

      init() {
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((responseText) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('.shopify-section');

            if (sectionInnerHTML === null) return;

            const recommendations = sectionInnerHTML.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (recommendations && recommendations.querySelector('.product-card')) {
              this.dispatchEvent(new CustomEvent('recommendations:loaded'));
            } else {
              if (recommendations && recommendations.classList.contains('complementary-products')) {
                this.closest('.product__block')?.remove();
              } else {
                this.closest('.shopify-section')?.remove();
              }
              this.dispatchEvent(new CustomEvent('recommendations:empty'));
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }
    }
  );
}
